










import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({})
export default class CrashDirection extends Vue {
    @Prop() public readonly angles!: any

    public getAngles() {
        return this.angles.split(",").map((angle: any) => {
            return 90 - angle
        })
    }
}
